import React from "react"
import { ThemeProvider } from "styled-components"
import { MenuProvider } from "./src/components/MenuContext"
import { AnimatePresence } from "framer-motion"
import { theme } from "./src/styles/theme"
import { GlobalStyle } from "./src/styles/GlobalStyles"

export function wrapPageElement({ element }) {
  return <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
}

export function wrapRootElement({ element }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <MenuProvider>{element}</MenuProvider>
    </ThemeProvider>
  )
}
